import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import app from '@/app';

const isDevEnv = process.env.NODE_ENV === 'development';
const isTestEnv = process.env.NODE_ENV === 'test';

// execute only in beta/production env
if (!isDevEnv && !isTestEnv) {
  const appVersion = import.meta.env.VUE_APP_VERSION;
  const bugsnagApiKey = import.meta.env.VUE_APP_BUGSNAG_API_KEY;

  if (bugsnagApiKey) {
    const bugsnagReportStage = import.meta.env.VUE_APP_BUGSNAG_REPORT_STAGE;
    const releaseStage = bugsnagReportStage !== undefined
      ? bugsnagReportStage
      : process.env.NODE_ENV;

    Bugsnag.start({
      apiKey: bugsnagApiKey,
      appVersion,
      releaseStage,
      plugins: [new BugsnagPluginVue()],
      onError(event) {
        // "ResizeObserver loop ..." is NOT an error. It is a benign browser signal
        // meaning some resize callbacks were deferred to the next animation frame to
        // avoid a layout loop — nothing throws and there is no user impact. The browser
        // dispatches it on `window`, so Bugsnag picks it up and it floods every route
        // (Vuetify uses ResizeObserver heavily). Discard it.
        const message = event.errors?.[0]?.errorMessage ?? '';
        if (message.includes('ResizeObserver loop')) {
          return false;
        }

        // Chain every hop: `auth` defaults to an object but `role` comes straight from
        // the login response, so a role-less account leaves it null. A throw HERE makes
        // Bugsnag drop the event, so this failure mode is invisible in the dashboard.
        const userRole = JSON.parse(localStorage.getItem('pepper_business'))?.auth?.role?.slug ?? 'not logged in';
        event.addMetadata('user', { role: userRole });
      },
    });

    app.use(Bugsnag.getPlugin('vue'));
  }
}

export default Bugsnag;
